import { defineComponent as _defineComponent } from 'vue';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BLink } from "bootstrap-vue";
import { computed, watch } from "vue";
import {} from "@/composables/genericTaskMonitor";
import { usePersistentProgressTaskMonitor } from "@/composables/persistentProgressMonitor";
import { useShortTermStorage } from "@/composables/shortTermStorage";
import FileSourceNameSpan from "@/components/FileSources/FileSourceNameSpan.vue";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PersistentTaskProgressMonitorAlert',
    props: {
        monitorRequest: null,
        useMonitor: null,
        taskId: { default: undefined },
        enableAutoDownload: { type: Boolean, default: false },
        inProgressMessage: { default: `Task is in progress. Please wait...` },
        completedMessage: { default: "Task completed successfully." },
        failedMessage: { default: "Task failed." },
        requestFailedMessage: { default: "Request failed." }
    },
    emits: ["onDismiss"],
    setup(__props, { emit }) {
        const props = __props;
        const { getDownloadObjectUrl } = useShortTermStorage();
        const { hasMonitoringData, isRunning, isCompleted, hasFailed, requestHasFailed, storedTaskId, status, hasExpired, expirationDate, monitoringData, start, reset, } = usePersistentProgressTaskMonitor(props.monitorRequest, props.useMonitor);
        const downloadUrl = computed(() => {
            // We can only download the result if the task is completed and the task type is short_term_storage.
            const requestId = props.taskId || storedTaskId;
            if (requestId && props.monitorRequest.taskType === "short_term_storage") {
                return getDownloadObjectUrl(requestId);
            }
            return undefined;
        });
        const remoteUri = computed(() => {
            return monitoringData.value?.request.remoteUri;
        });
        if (hasMonitoringData.value) {
            start();
        }
        watch(() => props.taskId, (newTaskId, oldTaskId) => {
            if (newTaskId && newTaskId !== oldTaskId) {
                start({
                    taskId: newTaskId,
                    taskType: props.monitorRequest.taskType,
                    request: props.monitorRequest,
                    startedAt: new Date(),
                });
            }
        });
        watch(() => isCompleted.value, (completed) => {
            // We check for props.taskId to be defined to avoid auto-downloading when the task is completed and
            // the component is first mounted like when refreshing the page.
            if (completed && props.enableAutoDownload && downloadUrl.value && props.taskId) {
                window.open(downloadUrl.value, "_blank");
            }
        });
        function dismissAlert() {
            reset();
            emit("onDismiss");
        }
        return { __sfc: true, props, emit, getDownloadObjectUrl, hasMonitoringData, isRunning, isCompleted, hasFailed, requestHasFailed, storedTaskId, status, hasExpired, expirationDate, monitoringData, start, reset, downloadUrl, remoteUri, dismissAlert, faSpinner, FontAwesomeIcon, BAlert, BLink, FileSourceNameSpan, UtcDate };
    }
});
